import * as types from "../types";

const initialState = {
  loading: false,
  thresholdValue: null,
  requestDevice: null,
  error: null,
};

export default function fetchThresholdValueReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.FETCH_THRESHOLD_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_THRESHOLD_SUCCESS:
      return {
        ...state,
        loading: false,
        thresholdValue: action.payload.thresholdValue,
      };

    case types.FETCH_THRESHOLD_FAILURE:
      return {
        ...state,
        loading: false,
        thresholdValue: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
